import React from 'react';
import { Judge, Type } from '../../../../../api/responses';
import { PlayerNumber } from '../../styles';
import {
  JudgesName,
  JudgesWrapper,
  JudgeTitle,
  JudgeWrapper,
  JudgeItem,
  Name,
} from './styles';

type JudgesProps = {
  judges?: Judge | Judge[] | null;
  competitionType: Type;
  lang: string;
};

const Judges = ({ judges, competitionType, lang = 'ru' }: JudgesProps) => {
  const sortedJudges = Array.isArray(judges)
    ? [...judges].sort((a, b) => a.position - b.position)
    : [judges];

  const employeeJudges = sortedJudges.filter(
    (judge) => judge?.voter_type === 'employee'
  );
  const negotiatorJudges = sortedJudges.filter(
    (judge) => judge?.voter_type === 'negotiator'
  );
  const founderJudges = sortedJudges.filter(
    (judge) => judge?.voter_type === 'founder'
  );
  return (
    <>
      {competitionType === 'quick' && (
        <JudgeWrapper>
          <JudgeTitle>
            {lang === 'ru'
              ? `Судьи "Отправляющие на переговоры"`
              : 'Negotiator voters'}
          </JudgeTitle>
          {!!judges &&
            sortedJudges.map((judge, index) => (
              <React.Fragment key={judge?.id ?? index}>
                {judge && (
                  <JudgeItem>
                    {judge.vote_for && (
                      <PlayerNumber $playerNumber={judge.vote_for}>
                        {judge.vote_for}
                      </PlayerNumber>
                    )}
                    <Name>
                      {judge?.last_name} {judge?.first_name}
                    </Name>
                  </JudgeItem>
                )}
              </React.Fragment>
            ))}
        </JudgeWrapper>
      )}
      {competitionType !== 'quick' && (
        <JudgesWrapper>
          <JudgesName>{lang === 'ru' ? 'СУДЬИ' : 'VOTERS'}</JudgesName>
          <JudgeWrapper>
            <JudgeTitle>
              {lang === 'ru' ? 'Нанимающиеся на работу' : 'Employees'}
            </JudgeTitle>
            {employeeJudges.map((judge, index) => (
              <React.Fragment key={judge?.id ?? index}>
                {judge && (
                  <JudgeItem>
                    {judge.vote_for && (
                      <PlayerNumber $playerNumber={judge.vote_for}>
                        {judge.vote_for}
                      </PlayerNumber>
                    )}
                    <Name>
                      {judge.last_name} {judge.first_name}
                    </Name>
                  </JudgeItem>
                )}
              </React.Fragment>
            ))}
          </JudgeWrapper>
          <JudgeWrapper>
            <JudgeTitle>
              {lang === 'ru' ? 'Отправляющие на переговоры' : 'Negotiators'}
            </JudgeTitle>
            {negotiatorJudges.map((judge, index) => (
              <React.Fragment key={judge?.id ?? index}>
                {judge && (
                  <JudgeItem>
                    {judge.vote_for && (
                      <PlayerNumber $playerNumber={judge.vote_for}>
                        {judge.vote_for}
                      </PlayerNumber>
                    )}
                    <Name>
                      {judge.last_name} {judge.first_name}
                    </Name>
                  </JudgeItem>
                )}
              </React.Fragment>
            ))}
          </JudgeWrapper>
          <JudgeWrapper>
            <JudgeTitle>
              {lang === 'ru' ? 'Доверяющие собственность' : 'Founders'}
            </JudgeTitle>
            {founderJudges.map((judge, index) => (
              <React.Fragment key={judge?.id ?? index}>
                {judge && (
                  <JudgeItem>
                    {judge.vote_for && (
                      <PlayerNumber $playerNumber={judge.vote_for}>
                        {judge.vote_for}
                      </PlayerNumber>
                    )}
                    <Name>
                      {judge.last_name} {judge.first_name}
                    </Name>
                  </JudgeItem>
                )}
              </React.Fragment>
            ))}
          </JudgeWrapper>
        </JudgesWrapper>
      )}
    </>
  );
};

export default Judges;
